module.exports = __webpack_public_path__ + "img/back-secciones-vacio.a8f33ca1.png";